module.exports = __webpack_public_path__ + "static/media/example02-04.a69d5513.svg";